import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const pharmacyService = {
  // Get pharmacy profile
  async getProfile() {
    const response = await api.get('/pharmacy/profile');
    return response.data;
  },

  // Create pharmacy profile (for new pharmacy users)
  async createProfile(profileData) {
    const response = await api.post('/pharmacy/profile', profileData);
    return response.data;
  },

  // Update pharmacy profile
  async updateProfile(profileData) {
    const response = await api.put('/pharmacy/profile', profileData);
    return response.data;
  },

  // Search pharmacies (public)
  async searchPharmacies(filters = {}) {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });
    
    const response = await api.get(`/pharmacy/search?${params}`);
    return response.data;
  },

  // Get nearby pharmacies
  async getNearbyPharmacies(location = null, radius = 10) {
    const params = new URLSearchParams();
    if (location) {
      params.append('latitude', location.latitude);
      params.append('longitude', location.longitude);
    }
    params.append('radius', radius);
    
    const response = await api.get(`/pharmacy/nearby?${params}`);
    return response.data;
  },

  // Get available riders
  async getAvailableRiders() {
    const response = await api.get('/pharmacy/riders');
    return response.data;
  },

  // Customer: Get favorite pharmacies
  async getFavoritePharmacies() {
    const response = await api.get('/pharmacy/favorites');
    return response.data;
  },

  // Customer: Add pharmacy to favorites
  async addToFavorites(pharmacyId) {
    const response = await api.post('/pharmacy/favorites', { pharmacyId });
    return response.data;
  },

  // Customer: Remove pharmacy from favorites
  async removeFromFavorites(pharmacyId) {
    const response = await api.delete(`/pharmacy/favorites/${pharmacyId}`);
    return response.data;
  },

  // Verification methods
  async getVerificationStatus() {
    const response = await api.get('/pharmacy/verification');
    return response.data;
  },

  async uploadVerificationDocument(documentType, file) {
    console.log('Uploading document:', { documentType, file });
    const formData = new FormData();
    formData.append('document', file);
    formData.append('documentType', documentType);
    
    console.log('FormData contents:');
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }
    
    const response = await api.post('/pharmacy/verification/documents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log('Upload response:', response.data);
    return response.data;
  },

  async submitForVerification() {
    console.log('Submitting pharmacy verification...');
    try {
      const response = await api.post('/pharmacy/verification/submit');
      console.log('Pharmacy verification submitted successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error submitting pharmacy verification:', error);
      throw error;
    }
  }
};

export default pharmacyService;
